"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var F_PlainDate_1 = __importDefault(require("./F_PlainDate"));
var PlainDateBuilder_1 = require("./PlainDateBuilder");
var F_PlainDate_Is = /** @class */ (function () {
    /** @hidden */
    function F_PlainDate_Is(plainDate, negated) {
        if (negated === void 0) { negated = false; }
        this.plainDate = plainDate;
        this.negated = negated;
        this.after = this.after.bind(this);
        this.applyNot = this.applyNot.bind(this);
        this.not = this.not.bind(this);
        this.before = this.before.bind(this);
        this.equal = this.equal.bind(this);
    }
    /** @hidden */
    F_PlainDate_Is.prototype.applyNot = function (input) {
        if (this.negated) {
            return !input;
        }
        return input;
    };
    F_PlainDate_Is.prototype.not = function () {
        return new F_PlainDate_Is(this.plainDate, !this.negated);
    };
    F_PlainDate_Is.prototype.after = function (arg1, arg2, arg3) {
        var _a;
        var otherPlainDateIso = arg1 instanceof F_PlainDate_1.default ? arg1.toIso() : (_a = (0, PlainDateBuilder_1._constructPlainDate)(arg1, arg2, arg3)) === null || _a === void 0 ? void 0 : _a.toIso();
        if (!otherPlainDateIso) {
            throw new Error('not other date');
        }
        return this.applyNot(this.plainDate.since(otherPlainDateIso).days > 0);
    };
    F_PlainDate_Is.prototype.before = function (arg1, arg2, arg3) {
        var _a;
        var otherPlainDateIso = arg1 instanceof F_PlainDate_1.default ? arg1.toIso() : (_a = (0, PlainDateBuilder_1._constructPlainDate)(arg1, arg2, arg3)) === null || _a === void 0 ? void 0 : _a.toIso();
        if (!otherPlainDateIso) {
            throw new Error('not other date');
        }
        return this.applyNot(this.plainDate.since(otherPlainDateIso).days < 0);
    };
    F_PlainDate_Is.prototype.equal = function (arg1, arg2, arg3) {
        var _a;
        var otherPlainDateIso = arg1 instanceof F_PlainDate_1.default ? arg1.toIso() : (_a = (0, PlainDateBuilder_1._constructPlainDate)(arg1, arg2, arg3)) === null || _a === void 0 ? void 0 : _a.toIso();
        if (!otherPlainDateIso) {
            throw new Error('not other date');
        }
        return this.applyNot(this.plainDate.equals(otherPlainDateIso));
    };
    return F_PlainDate_Is;
}());
exports.default = F_PlainDate_Is;
//# sourceMappingURL=F_PlainDate_Is.js.map